import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// App Check imports
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
    apiKey: "AIzaSyBl27OvtNv0RAEJEhAIoftdmWeMPldtOoY",
    authDomain: "dxt-data.firebaseapp.com",
    projectId: "dxt-data",
    storageBucket: "dxt-data.firebasestorage.app",
    messagingSenderId: "301461748654",
    appId: "1:301461748654:web:257897e1704e9a0aa7263f",
    measurementId: "G-2KME1YGQ4Y"
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app, "gs://dxt-law-app-files");
export const db = getFirestore(app, "dxt-law-db");
export const auth = getAuth(app);

// Initialize Firebase App Check with reCAPTCHA v3
// Site key: 6LeJZT4sAAAAAIHKshStIRU5u3OLuEIUbzYE-bKu
if (typeof window !== 'undefined') {
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6LeJZT4sAAAAAIHKshStIRU5u3OLuEIUbzYE-bKu'),
        isTokenAutoRefreshEnabled: true
    });
}

// Initialize Firebase Analytics (GA4)
// Best-effort to avoid crashing in non-browser contexts.
try {
    if (typeof window !== 'undefined') {
        getAnalytics(app);
    }
} catch {
    // no-op
}
